module.exports = __webpack_public_path__ + "media/images/emblems/Cureglia-coat_of_arms-7d7b7f012085c7de27c898dfb0fcd079.svg";